<div class="vbm-comment-section">
  <div class="vbm-comment-box" *ngIf="IsCommentAllowed">
    <a href="javascript:void(0);" class="vbm-left-image cursor-default">
      <img src="{{UserImagePath}}" alt="{{bs.getResource('rbkey_CmmntUsrImgLBL')}}">
    </a>
    <div class="vbm-right-comment-box">
      <textarea maxlength="250" name="" id="txtAdd{{ParenThreadId}}" rows="1" class="comment-input" placeholder="{{bs.getResource('rbkey_CnvrstnCmmntPlcHldrLBL')}}"></textarea>
      <div *ngIf="ValidationMsg">
      </div>
      <a role="button" href="javascript:void(0);" class="submit-button" id="btnAdd{{ParenThreadId}}" (click)="AddComment(ParenThreadId,ConversationId,UserId,Type)">{{bs.getResource('rbkey_AvlablChnnlSbmtLBL')}}</a>
      <div class="arrow-left"></div>
    </div>
  </div>
  <div class="vbm-comment-box" *ngFor="let item of CommentList;let i = index" id="morecomment">
    <div *ngIf="IsCommentAllowed">
      <div class="vbm-comment-box" id="Thread{{item['ThreadId']}}" *ngIf="item['IsEditable']" style="display:none;">
        <a href="javascript:void(0);" class="vbm-left-image cursor-default">
          <img src="{{item['UserImagePath']}}" alt="{{bs.getResource('rbkey_CmmntUsrImgLBL')}}">
        </a>
        <div class="vbm-right-comment-box">
          <textarea autofocus="autofocus" name="" maxlength="250" id="Text{{item['ThreadId']}}" rows="1" class="comment-input" placeholder="{{bs.getResource('rbkey_CnvrstnCmmntPlcHldrLBL')}}"></textarea>
          <div style="display:none" id="CmtValdiation{{item['ThreadId']}}">
          </div>
          <a href="javascript:void(0);" (click)="EditComment(item['ThreadId'],item['Type'],i)" class="submit-button">{{bs.getResource('rbkey_AvlablChnnlSbmtLBL')}}</a>
          <div class="arrow-left"></div>
        </div>
      </div>
    </div>
    <a href="javascript:void(0);" class="vbm-left-image cursor-default" *ngIf="item['CommentText']!=''">
      <img src="{{item['UserImagePath']}}" alt="{{bs.getResource('rbkey_CmmntUsrImgLBL')}}">
    </a>
    <div class="vbm-right-comment-box" id="Comment{{item['ThreadId']}}" *ngIf="item['CommentText']!=''">
      <div class="right-comment-box-details">
        <div class="cb-top">
          <div class="cbt-name">
            <a role="text" class="name-link" href="javascript:void(0);" style="cursor:default">{{item['UserName']}}</a>
            <span class="cbt-post">{{item.JobRole}}</span>
          </div>
          <div class="vbm-right-menu" *ngIf="item['IsEditable']">
            <a href="javascript:void(0);" data-toggle="dropdown" class="dropdown-toggle vlb-menu"></a>
            <ul role="menu" class="dropdown-menu animated fadeIn right">
              <li *ngIf="IsCommentAllowed">
                <a href="#" (click)="EditElements(item['ThreadId'])" style="display: block;">{{bs.getResource('rbkey_CnvrstnCmmntEdtBTN')}}</a>
              </li>
              <li>
                <a href="#" (click)="DeleteComment(item['ThreadId'],i,item['ParentThreadId'],item['ConversationId'],item['UserId'],item['Type'])" style="display: block;">{{bs.getResource('rbkey_CnvrstnCmmntDltBTN')}}</a>
              </li>
            </ul>
          </div>
          <div class="vbm-right-menu" *ngIf="enableRebuseComment(item)">
              <a href="javascript:void(0);" data-toggle="dropdown" class="dropdown-toggle vlb-menu"></a>
              <ul role="menu" class="dropdown-menu animated fadeIn right">
                  <li>                                         
                      <a href="javascript:void(0);" (click)="postRebuseComment(item)" style="display: block;">{{bs.getResource('rbkey_RprtAbsCmmntLBL')}}</a>
                  </li>
              </ul>
          </div>
          <div class="stars">  
              <span  *ngIf="enableRebuseFlag(item)">
                  <a href="javascript:void(0)" class="fa-report-abuse fa fa-flag"></a>
              </span>
          </div>
          
        </div>
        <div class="cb-details-text">
          <span id="CommentText{{item['ThreadId']}}">{{item.CommentText}}</span>
        </div>
      </div>
      <div class="arrow-left"></div>
    </div>
  </div>
  <div *ngIf="ShowButton">
    <div *ngIf="NumberOfComments>=1">
      <a href="javascript:void(0);" class="show-more-comments" (click)="showMoreComments(ParenThreadId,ConversationId,UserId,Type)">{{bs.getResource('rbkey_CnvrstnShwMrLBL')}}</a>
    </div>
  </div>
</div>
